import React from 'react'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Theme/Common'
import { Icon } from '@mobi/component-library/Common/Icon'
import type { KambiSportsSelection } from '@mobi/betslip/types'
import { RaceCountdown } from '@core/Components/RaceCountdown'
import { CountdownPillStyled } from '@core/Areas/Quickbet/Components/Common.styles'
import {
  CompetitionAndTournamentStyled,
  MarketPillStyled,
  SingleSelectionStyled,
} from '../BetInfoHeader/Components/Common/Header.styles'

export const KambiSportsHeader: React.FC<{ selection: KambiSportsSelection }> = ({ selection }) => {
  if (selection.betSelectionType === 'single') {
    const betOffer = selection.betOffers[0]

    return (
      <WrapperStyled>
        <div>
          <Icon type='tab' />

          <CompetitionAndTournamentStyled style={{ lineHeight: 1, margin: 0, padding: 0 }}>
            {selection.events[0].englishName}
          </CompetitionAndTournamentStyled>
        </div>

        <div>
          <MarketPillStyled>{betOffer.criterion.label}</MarketPillStyled>

          <CountdownPillStyled>
            <RaceCountdown
              displaySize='1.2rem'
              raceStartTime={new Date(selection.events[0].start)}
            />
          </CountdownPillStyled>
        </div>

        <SingleSelectionStyled data-tid-single-selection>
          <span
            style={{
              width: '3rem',
              height: '3rem',
              borderRadius: '50%',
              background: '#47245D',
              flexShrink: 0,
            }}
          />{' '}
          {getSelectionName(betOffer)}
        </SingleSelectionStyled>
      </WrapperStyled>
    )
  }

  return (
    <pre style={{ fontSize: '1.6rem' }}>
      TODO: <span style={{ textTransform: 'capitalize' }}>{selection.betSelectionType}</span>
    </pre>
  )
}

// =============
// Local Helpers
// =============

function getSelectionName(betOffer: BetOffer): string {
  const outcome = betOffer.outcomes[0]

  return `${outcome.participant || outcome.label}${outcome.line ? ' ' + outcome.line / 1000 : ''}`
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,

  '> div': {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.smx1,

    ':nth-of-type(2)': {
      justifyContent: 'space-between',
    },
  },
})

// =====
// Types
// =====

type BetOffer = KambiSportsSelection['betOffers'][0]
